import * as a from '../actions/manager'
import { createReducer } from 'redux-act'
var month = (new Date().getMonth()+1);

let DEFAULT_STATE = {
  managers: [],
  data:[],
  allData:[],
  show:false,
  filter:{
    status:"manager",
    year:new Date().getFullYear(),
    month: month < 10 ? "0"+month : month
  }
}
export default createReducer(
  {
    [a.getManagersSuccessful]: (state, payload) => {
      return Object.assign({}, state, {
        managers: payload
      });
    },
    [a.getManagersFailure]: (state, payload) => {
      return {
        ...state
      }
    },
    [a.getManagerRequestsSuccessful]: (state, payload) => {
      const requests = payload.requests;
      return{
        ...state,
        data:requests,
        allData:requests
      }
    },
    [a.getManagerRequestsFailure]: (state, payload) => {
      return {
        ...state
      }
    },
  },
  DEFAULT_STATE
);